import { render, staticRenderFns } from "./ApartmentForm.vue?vue&type=template&id=bea207b4&scoped=true&"
import script from "./ApartmentForm.vue?vue&type=script&lang=js&"
export * from "./ApartmentForm.vue?vue&type=script&lang=js&"
import style0 from "./ApartmentForm.vue?vue&type=style&index=0&id=bea207b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea207b4",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QInput,QField});
